<template>
  <td colspan="8">
    <span v-for="(header, index) in headers" :key="index" class="group-header">{{ header }}</span>
  </td>
</template>

<script lang="ts">
import Vue from 'vue';
import { getFormattedDate } from '@/services/date-formater';

export default Vue.extend({
  name: 'SelectionTableGroupHeader',
  props: {
    groupKey: {
      type: String,
      required: true
    }
  },
  computed: {
    headers(): string[] {
      const headers = this.groupKey.split('::').slice(1); // remove supplier code since no need in header
      const lastIndex = headers.length - 1;
      headers[lastIndex] = getFormattedDate(headers[lastIndex], '/');
      return headers;
    }
  }
});
</script>

<style lang="scss" scoped>
.group-header {
  &::before {
    content: '|';
    margin: 1em;
  }

  &:last-of-type::after {
    content: '|';
    margin: 1em;
  }

  font-weight: bold;
}
</style>
